import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getCustomerTransactions } from '../../services/user';
import useUser from '../global/useUser';

function useGetCustomerPayments(customerId: string) {
  const { user } = useUser();

  const query = useInfiniteQuery({
    queryKey: ['customer-payments', customerId, user?.business.id],
    queryFn: ({ pageParam }) =>
      getCustomerTransactions(customerId, user?.business.id!, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    enabled: !!customerId && !!user?.business.id,
    staleTime: 0,
    gcTime: 0,
  });

  const pages = query.data?.pages;
  const payments = useMemo(
    () => pages?.flatMap(page => page.transactions) ?? [],
    [pages],
  );

  return {
    payments,
    isLoading: query.isPending,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: () => {
      query.fetchNextPage();
    },
    isError: query.isError && !query.data,
    isFetchNextPageError: query.isFetchNextPageError,
    error: query.error,
  };
}

export default useGetCustomerPayments;
